export default __webpack_public_path__ + "assets/mp3/0b8b6e245b1e9e8c954262eeedb67144.mp3";